<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left py-3">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Usuarios</h2>
          <p class="text-purple-manax pl-3 subtitle-section">Listado Completo de Usuarios del Sistema</p>
        </span>
        <span class="pull-right py-3 pr-3">
          <button mat-raised-button type="button" class="btn btn-manax p-2" (click)="openNewUserModal()">
            <i class="material-icons">add</i> Nuevo Usuario
          </button>
        </span>
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortUsers($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <th class="p-0 pl-2" width="1%">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell" *ngIf="isManax">
                Empresa<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.company"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="height: 70px; position: relative;"
                mat-sort-header="username">
                Usuario<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.username"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;" />
              </th>
              <th class="d-none d-md-table-cell">
                Trabajador<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.worker"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell">
                Roles<br>
                <select [(ngModel)]="filter.filters.roles" (ngModelChange)="getUsers(true)"
                  (click)="$event.stopPropagation()" class="filter small" style="max-width: 200px;">
                  <option [ngValue]="undefined"> todos </option>
                  <option [ngValue]="role" *ngFor="let role of roleLabelsKeys">{{roleLabels[role]}}</option>
                </select>
              </th>
              <th class="d-none d-md-table-cell align-top"
                style="height: 65px; position: relative; max-width: 1000px;" mat-sort-header="isDeleted">
                Estado<br>
                <select class="filter small" [(ngModel)]="filter.filters.isDeleted" (ngModelChange)="getUsers(true)"
                  (click)="$event.stopPropagation()"
                  style="max-width: 1000px; position: absolute; top: 27px; left: 0px;">
                  <option [ngValue]="false"> activo </option> <!-- isDeleted: false -->
                  <option [ngValue]="true"> inactivo </option> <!-- isDeleted: true -->
                  <option [ngValue]="undefined"> todos </option>
                </select>
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort] || 'ninguno'}}</span>
                <span class="text-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0" width="1%">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>

                  <button mat-menu-item (click)="openExportItems(true)">
                    <span>Exportar Todo</span>
                  </button>

                  <button mat-menu-item (click)="openExportItems(false)">
                    <span>Exportar Selección</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortUsers(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortUsers('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let user of users" [class.text-danger]="user.isDeleted" class='cursor-pointer'
              (click)="openUsersModal(user, true)">

              <!-- All -->
              <td class="p-0 pl-2 align-middle" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(user._id)"
                      [checked]="selection.all || selection[user._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell" *ngIf="isManax">
                <span *ngFor="let company of user.company">{{company.name}}<br></span>
              </td>
              <td class="d-none d-md-table-cell">{{user.username}}</td>
              <td class="d-none d-md-table-cell">{{user.worker?.firstname}} {{user.worker?.lastname}}</td>
              <td class="d-none d-md-table-cell">
                <span *ngFor="let role of user.roles">{{roleLabels[role.name || '']}}<br></span>
              </td>
              <td class="d-none d-md-table-cell">
                <span *ngIf="!user.isDeleted">activo</span>
                <span *ngIf="user.isDeleted">inactivo</span>
              </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <span class="font-weight-bold">{{user.username}}</span><br>
                <span class="small">{{user.worker?.firstname}} {{user.worker?.lastname}}</span><br>
                <span class="small pull-left">
                  <span *ngIf="user.roles?.length">
                    roles: <span *ngFor="let role of user.roles"> {{role.name}}. </span>
                  </span>
                </span><br>
                <span class="small pull-right" *ngIf="user.isDeleted">borrada</span>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openUsersModal(user, true)">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openUsersModal(user)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteUserConfirm(user, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteUserConfirm(user)" *ngIf="!user.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreUserConfirm(user)" *ngIf="user.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-manax" *ngIf="!loading">
            <tr>
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ users.length }} usuarios</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>